// extracted by css-extract-rspack-plugin
module.exports =  {"emphasize":"RemoveCouponAdAdminDialog__emphasize___Gy4Io"};